import React from 'react';

import { useSeoMetada } from '../hooks/useSeoMetadata';

import Header from '../components/Header';
import Article from '../components/Article';
import Layout from '../components/Layout';
import Author from '../components/Author';
import Section from '../components/Section';

const ArticleContainer = ({ data }) => {
  const { content } = data;
  const {
    seoMetadata: contentfulSeoMetadata,
    title,
    subtitle,
    coverImage,
    author
  } = content;

  const { helmetMetadata } = useSeoMetada(contentfulSeoMetadata, {
    title,
    description: subtitle?.childMarkdownRemark?.rawMarkdownBody,
    ogImage: coverImage
  });

  return (
    <Layout data={data} helmetMetadata={helmetMetadata}>
      <Header
        header={{
          illustration: {
            file: coverImage,
            isBackgroundImage: true,
            isDescriptionSmall: true
          },
          blockContent: {
            title,
            description: <Author author={author} version="secondary-text" />
          },
          isNavbarTransparent: true
        }}
      />
      <Section
        section={{
          version: 'children',
          contentful_id: content?.contentful_id
        }}
      >
        <Article article={content} />
      </Section>
    </Layout>
  );
};

export default ArticleContainer;
